import axios from 'src/axios';
import { APICONSTANTS } from 'src/components/Constants';
import { mergeFieldsOptions } from '../constants';

let _cache = null;
let _inflight = null;

function legacyGroups() {
  return [
    {
      group: 'Merge fields',
      fields: mergeFieldsOptions.map((o) => ({
        token: o.label,
        path: o.id,
        label: o.label,
        group: 'Merge fields',
        aliases: [String(o.label).toLowerCase()],
        kind: 'scalar',
        source: 'legacy'
      }))
    }
  ];
}

/**
 * Fetch (and cache) the catalogue. Never throws — falls back to legacy options.
 * @returns {Promise<{ v2Enabled:boolean, groups:object[], fromBackend:boolean }>}
 */
export async function fetchMergeFieldCatalogue() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(APICONSTANTS.getMergeFieldCatalogue)
    .then(({ data }) => {
      _cache = {
        v2Enabled: !!data.v2Enabled,
        deploymentId: data.deploymentId,
        groups:
          Array.isArray(data.groups) && data.groups.length
            ? data.groups
            : legacyGroups(),
        fromBackend: true
      };
      return _cache;
    })
    .catch(() => {
      _cache = { v2Enabled: false, groups: legacyGroups(), fromBackend: false };
      return _cache;
    })
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

export function invalidateCatalogueCache() {
  _cache = null;
}

export function flattenGroups(groups) {
  return (groups || []).reduce((acc, g) => acc.concat(g.fields || []), []);
}

export function collectionsOf(groups) {
  return flattenGroups(groups).filter((d) => d.kind === 'collection');
}
